<template>
  <!--//RPD Mobile Template v0.1.1
    //Copyright(c) 2022 Blue Cover Six LLC / John Molt (BCS)
    // Code licensed under contract To Reno Police Department / City of Reno, in perpetuity-->

  <div id="home">
    <!-- style="width:8.5in;"
                      :show-layout="true"
                      :float-layout="false"
                      :enable-download="true"
                      :preview-modal="true"
                      :paginate-elements-by-height="1400"
                      filename="hee hee"
                      :pdf-quality="2"
                      :manual-pagination="false"
                      pdf-format="a4"
                      pdf-orientation="portrait"
                      pdf-content-width="8.5in"
                      ref="html2Pdf" -->

    <div>
      <section slot="pdf-content" class="bottom-pad">
        <!-- PDF Content Here -->
        <div
          class="header-main flex-1 content-header"
          v-for="data in header_main"
          v-bind:key="data.id"
          v-bind:data="data"
        >
          <h3>RENO POLICE DEPARTMENT</h3>
          <h3>{{ data.casenum }}</h3>
        </div>
        <div class="header-main flex-2-main content-header">
          <div class="badge">
            <img src="../images/gold_badge_h80.png" />
          </div>
          <div class="address flex-child-1 caps">
            <h5>p.o. box 1900</h5>
            <h5>455 E 2nd St</h5>
            <h5>775-334-2175</h5>
          </div>
          <div
            class="date-type flex-child-1"
            v-for="data in header_main"
            v-bind:key="data.id"
            v-bind:data="data"
          >
            <h5><strong>Reported Date:</strong></h5>
            <h5 class="caps">{{ data.rep_date }}</h5>
            <h5><strong>Incident Type:</strong></h5>
            <h5 class="caps">{{ data.inc_type }}</h5>
          </div>
        </div>

        <!-- ADMINISTRATIVE INFO -->
        <div
          id="admin_info"
          v-for="contents in admin_content"
          v-bind:key="contents.id"
        >
          <!-- HEADER -->
          <div class="content-header-labels">
            <div class="header-purple">
              <h4>Administrative Information</h4>
            </div>
          </div>
          <!-- CONTENT -->
          <div class="content-header-labels">
            <div class="content-parent-flex">
              <div class="rows-flex">
                <div class="row-col-flex">
                  <h6>Agency</h6>
                  <h5 class="caps">{{ contents.agency }}</h5>
                </div>
                <div class="row-col-flex">
                  <h6>oca</h6>
                  <h5 class="caps">{{ contents.oca }}</h5>
                </div>
                <div class="row-col-flex">
                  <h6>Supplement Number</h6>
                  <h5 class="caps">{{ contents.supplementNum }}</h5>
                </div>
                <div class="row-col-flex">
                  <h6>Reported Date</h6>
                  <h5 class="caps">{{ contents.reportedDate }}</h5>
                </div>
                <div class="row-col-flex">
                  <h6>Reported Time</h6>
                  <h5 class="caps">{{ contents.reportedTime }}</h5>
                </div>
                <div class="row-col-flex">
                  <h6>CAD Call Number</h6>
                  <h5 class="caps">{{ contents.cadCallNum }}</h5>
                </div>
                <div class="row-col-flex">
                  <h6>Status</h6>
                  <h5 class="caps">{{ contents.status }}</h5>
                </div>
                <div class="row-col-flex">
                  <h6>Rep/Incident Type</h6>
                  <h5 class="caps">{{ contents.repIncType }}</h5>
                </div>
                <div class="row-col-flex">
                  <h6>Location</h6>
                  <h5 class="caps">{{ contents.location }}</h5>
                </div>
                <div class="row-col-flex">
                  <h6>City</h6>
                  <h5 class="caps">{{ contents.city }}</h5>
                </div>
                <div class="row-col-flex">
                  <h6>Zip Code</h6>
                  <h5 class="caps">{{ contents.zipCode }}</h5>
                </div>
                <div class="row-col-flex">
                  <h6>Rep Dist</h6>
                  <h5 class="caps">{{ contents.repDist }}</h5>
                </div>
                <div class="row-col-flex">
                  <h6>Area</h6>
                  <h5 class="caps">{{ contents.area }}</h5>
                </div>
                <div class="row-col-flex">
                  <h6>Beat</h6>
                  <h5 class="caps">{{ contents.beat }}</h5>
                </div>
                <div class="row-col-flex">
                  <h6>From Date</h6>
                  <h5 class="caps">{{ contents.fromDate }}</h5>
                </div>
                <div class="row-col-flex">
                  <h6>From Time</h6>
                  <h5 class="caps">{{ contents.fromTime }}</h5>
                </div>
                <div class="row-col-flex">
                  <h6>Emp #</h6>
                  <h5 class="caps">{{ contents.empNum }}</h5>
                </div>
                <div class="row-col-flex">
                  <h6>Assignment</h6>
                  <h5 class="caps">{{ contents.assignment1 }}</h5>
                </div>
                <div class="row-col-flex">
                  <h6>Author</h6>
                  <h5 class="caps">{{ contents.author }}</h5>
                </div>
                <div class="row-col-flex">
                  <h6>Assignment</h6>
                  <h5 class="caps">{{ contents.assignment2 }}</h5>
                </div>
                <div class="row-col-flex">
                  <h6>RMS Transfer</h6>
                  <h5 class="caps">{{ contents.rmsTransfer }}</h5>
                </div>
                <div class="row-col-flex">
                  <h6>Prop Trans Stat</h6>
                  <h5 class="caps">{{ contents.propTransStat }}</h5>
                </div>
                <div class="row-col-flex">
                  <h6>Property?</h6>
                  <h5 class="caps">{{ contents.property }}</h5>
                </div>
                <div class="row-col-flex">
                  <h6>Approving Officer</h6>
                  <h5 class="caps">{{ contents.approvingOfficer }}</h5>
                </div>
                <div class="row-col-flex">
                  <h6>Approval Date</h6>
                  <h5 class="caps">{{ contents.approvalDate }}</h5>
                </div>
                <div class="row-col-flex">
                  <h6>Approval Time</h6>
                  <h5 class="caps">{{ contents.approvalTime }}</h5>
                </div>
                <div class="row-col-flex">
                  <h6>Arrest/Pc Report</h6>
                  <h5 class="caps">{{ contents.arrestPcReport }}</h5>
                </div>
                <div class="row-col-flex">
                  <h6>Criminal Complaint</h6>
                  <h5 class="caps">{{ contents.criminalComplaint }}</h5>
                </div>
                <div class="row-col-flex">
                  <h6>Written Statement</h6>
                  <h5 class="caps">{{ contents.writtenStatement }}</h5>
                </div>
                <div class="row-col-flex">
                  <h6>#Offenses</h6>
                  <h5 class="caps">{{ contents.numOffenses }}</h5>
                </div>
                <div class="row-col-flex">
                  <h6>Offense</h6>
                  <h5 class="caps">{{ contents.offense }}</h5>
                </div>
                <div class="row-col-flex">
                  <h6>Description</h6>
                  <h5 class="caps">{{ contents.description }}</h5>
                </div>
                <div class="row-col-flex">
                  <h6>Complaint Type</h6>
                  <h5 class="caps">{{ contents.complaintType }}</h5>
                </div>
                <div class="row-col-flex">
                  <h6>AC</h6>
                  <h5 class="caps">{{ contents.ac }}</h5>
                </div>
                <div class="row-col-flex">
                  <h6>Use</h6>
                  <h5 class="caps">{{ contents.use }}</h5>
                </div>
                <div class="row-col-flex">
                  <h6>Bias</h6>
                  <h5 class="caps">{{ contents.bias }}</h5>
                </div>
                <div class="row-col-flex">
                  <h6>Loc</h6>
                  <h5 class="caps">{{ contents.loc }}</h5>
                </div>
                <div class="row-col-flex">
                  <h6>#Pr</h6>
                  <h5 class="caps">{{ contents.numPr }}</h5>
                </div>
                <div class="row-col-flex">
                  <h6>MOE</h6>
                  <h5 class="caps">{{ contents.moe }}</h5>
                </div>
                <div class="row-col-flex">
                  <h6>Act</h6>
                  <h5 class="caps">{{ contents.act }}</h5>
                </div>
                <div class="row-col-flex">
                  <h6>Weapon/Force</h6>
                  <h5 class="caps">{{ contents.weaponForce }}</h5>
                </div>
                <div class="row-col-flex">
                  <h6>IBRS</h6>
                  <h5 class="caps">{{ contents.ibrs }}</h5>
                </div>
                <div class="row-col-flex">
                  <h6>No</h6>
                  <h5 class="caps">{{ contents.no }}</h5>
                </div>
                <div class="row-col-flex">
                  <h6>Cargo?</h6>
                  <h5 class="caps">{{ contents.cargo }}</h5>
                </div>
                <div class="row-col-flex">
                  <h6>NV Offense</h6>
                  <h5 class="caps">{{ contents.nvOffense }}</h5>
                </div>
                <div class="row-col-flex">
                  <h6>Dom Violence?</h6>
                  <h5 class="caps">{{ contents.domViolence }}</h5>
                </div>
                <div class="row-col-flex">
                  <h6>#Child</h6>
                  <h5 class="caps">{{ contents.numChild }}</h5>
                </div>
                <div class="row-col-flex">
                  <h6>Med Atn?</h6>
                  <h5 class="caps">{{ contents.medAtn }}</h5>
                </div>
                <div class="row-col-flex">
                  <h6>Protection?</h6>
                  <h5 class="caps">{{ contents.protection }}</h5>
                </div>
                <div class="row-col-flex">
                  <h6>DV Card?</h6>
                  <h5 class="caps">{{ contents.dvCard }}</h5>
                </div>
                <!-- PEOPLE -->
                <div
                  class="rows-flex"
                  v-for="person in lstpersons"
                  v-bind:key="person.id"
                  v-bind:person="person"
                >
                  <div class="row-col-flex">
                    <h6>Link</h6>
                    <h5 class="caps">{{ person.link }}</h5>
                  </div>
                  <div class="row-col-flex">
                    <h6>Involvement</h6>
                    <h5 class="caps">{{ person.involvement }}</h5>
                  </div>
                  <div class="row-col-flex">
                    <h6>invl#</h6>
                    <h5 class="caps">{{ person.invlNum }}</h5>
                  </div>
                  <div class="row-col-flex">
                    <h6>Name</h6>
                    <h5 class="caps">{{ person.name }}</h5>
                  </div>
                  <div class="row-col-flex">
                    <h6>Race</h6>
                    <h5 class="caps">{{ person.race }}</h5>
                  </div>
                  <div class="row-col-flex">
                    <h6>Sex</h6>
                    <h5 class="caps">{{ person.sex }}</h5>
                  </div>
                  <div class="row-col-flex">
                    <h6>DOB</h6>
                    <h5 class="caps">{{ person.dob }}</h5>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <!-- PERSON SUMMARY -->
        <div id="person_summary">
          <!-- HEADER -->
          <div class="content-header-labels">
            <div class="header-purple">
              <h4>Person Summary</h4>
            </div>
          </div>

          <!-- CONTENT -->
          <div class="content-header-labels">
            <div class="content-parent-flex">
              <div
                class="rows-flex"
                v-for="person in lstpersons"
                v-bind:key="person.id"
                v-bind:person="person"
              >
                <div class="row-col-flex perscell1">
                  <h6>Link</h6>
                  <h5 class="caps">{{ person.link }}</h5>
                </div>
                <div class="row-col-flex perscell2">
                  <h6>Involvement</h6>
                  <h5 class="caps">{{ person.involvement }}</h5>
                </div>
                <div class="row-col-flex perscell3">
                  <h6>invl#</h6>
                  <h5 class="caps">{{ person.invlNum }}</h5>
                </div>
                <div class="row-col-flex perscell4">
                  <h6>Name</h6>
                  <h5 class="caps">{{ person.name }}</h5>
                </div>
                <div class="row-col-flex perscell5">
                  <h6>Race</h6>
                  <h5 class="caps">{{ person.race }}</h5>
                </div>
                <div class="row-col-flex perscell6">
                  <h6>Sex</h6>
                  <h5 class="caps">{{ person.sex }}</h5>
                </div>
                <div class="row-col-flex perscell7">
                  <h6>DOB</h6>
                  <h5 class="caps">{{ person.dob }}</h5>
                </div>
              </div>
            </div>
          </div>
        </div>

        <!-- PROPERTY SUMMARY -->
        <div id="prop_summary">
          <!-- HEADER -->
          <div class="content-header-labels">
            <div class="header-orange">
              <h4>Property Summary</h4>
            </div>
          </div>

          <!-- CONTENT -->
          <div class="content-header-labels">
            <div class="content-parent-flex">
              <div
                class="rows-flex"
                v-for="propSumm in propSummaries"
                v-bind:key="propSumm.id"
              >
                <div class="row-col-flex propcell1">
                  <h6>Involvement</h6>
                  <h5 class="caps">{{ propSumm.involvement }}</h5>
                </div>
                <div class="row-col-flex propcell2">
                  <h6>Description</h6>
                  <h5 class="caps">{{ propSumm.description }}</h5>
                </div>
              </div>
            </div>
          </div>
        </div>

        <!-- ARRESTEES -->
        <div
          id="arrestees"
          v-for="arrestee in arrestees"
          v-bind:key="arrestee.id"
        >
          <!-- HEADER -->
          <div class="content-header-labels">
            <div class="header-purple">
              <h4 class="caps">
                Arrestee {{ arrestee.invlNum }}: {{ arrestee.name }}
              </h4>
            </div>
          </div>

          <!-- CONTENT -->
          <div class="content-header-labels">
            <div class="content-parent-flex">
              <div class="rows-flex">
                <div class="row-col-flex">
                  <h6>Involvement</h6>
                  <h5 class="caps">{{ arrestee.involvement }}</h5>
                </div>
                <div class="row-col-flex">
                  <h6>Invl No</h6>
                  <h5 class="caps">{{ arrestee.invlNum }}</h5>
                </div>
                <div class="row-col-flex">
                  <h6>Type</h6>
                  <h5 class="caps">{{ arrestee.type }}</h5>
                </div>
                <div class="row-col-flex">
                  <h6>Name</h6>
                  <h5 class="caps">{{ arrestee.name }}</h5>
                </div>
                <div class="row-col-flex">
                  <h6>MNI</h6>
                  <h5 class="caps">{{ arrestee.mni }}</h5>
                </div>
                <div class="row-col-flex">
                  <h6>Race</h6>
                  <h5 class="caps">{{ arrestee.race }}</h5>
                </div>
                <div class="row-col-flex">
                  <h6>Sex</h6>
                  <h5 class="caps">{{ arrestee.sex }}</h5>
                </div>
                <div class="row-col-flex">
                  <h6>DOB</h6>
                  <h5 class="caps">{{ arrestee.dob }}</h5>
                </div>
                <div class="row-col-flex">
                  <h6>Age</h6>
                  <h5 class="caps">{{ arrestee.age }}</h5>
                </div>
                <div class="row-col-flex">
                  <h6>Ethnicity</h6>
                  <h5 class="caps">{{ arrestee.ethnicity }}</h5>
                </div>
                <div class="row-col-flex">
                  <h6>Juvenile?</h6>
                  <h5 class="caps">{{ arrestee.juvenile }}</h5>
                </div>
                <div class="row-col-flex">
                  <h6>Height</h6>
                  <h5 class="caps">{{ arrestee.height }}</h5>
                </div>
                <div class="row-col-flex">
                  <h6>Weight</h6>
                  <h5 class="caps">{{ arrestee.weight }}</h5>
                </div>
                <div class="row-col-flex">
                  <h6>Hair Color</h6>
                  <h5 class="caps">{{ arrestee.hairColor }}</h5>
                </div>
                <div class="row-col-flex">
                  <h6>Eye Color</h6>
                  <h5 class="caps">{{ arrestee.eyeColor }}</h5>
                </div>
                <div class="row-col-flex">
                  <h6>Dom Violence?</h6>
                  <h5 class="caps">{{ arrestee.domViolence }}</h5>
                </div>
                <div class="row-col-flex">
                  <h6>Res Status</h6>
                  <h5 class="caps">{{ arrestee.resStatus }}</h5>
                </div>
                <div class="row-col-flex">
                  <h6>OFN_INVL</h6>
                  <h5 class="caps">{{ arrestee.ofnInvl }}</h5>
                </div>
                <div class="row-col-flex">
                  <h6>Vic/Ofnd Age</h6>
                  <h5 class="caps">{{ arrestee.vicOfndAge }}</h5>
                </div>
                <div class="row-col-flex">
                  <h6>PRN</h6>
                  <h5 class="caps">{{ arrestee.prn }}</h5>
                </div>
                <div
                  class="rows-flex green-border-top"
                  v-for="address in arrestee.addresses"
                  v-bind:key="address.id"
                >
                  <div class="row-col-flex">
                    <h6>Type</h6>
                    <h5 class="caps">{{ address.type }}</h5>
                  </div>
                  <div class="row-col-flex">
                    <h6>Address</h6>
                    <h5 class="caps">{{ address.address }}</h5>
                  </div>
                  <div class="row-col-flex">
                    <h6>City</h6>
                    <h5 class="caps">{{ address.city }}</h5>
                  </div>
                  <div class="row-col-flex">
                    <h6>State</h6>
                    <h5 class="caps">{{ address.state }}</h5>
                  </div>
                  <div class="row-col-flex">
                    <h6>Zip Code</h6>
                    <h5 class="caps">{{ address.zipCode }}</h5>
                  </div>
                  <div class="row-col-flex">
                    <h6>Date</h6>
                    <h5 class="caps">{{ address.date }}</h5>
                  </div>
                </div>
                <!-- arrestee ids -->
                <div
                  class="rows-flex green-border-top"
                  v-for="id in arrestee.ids"
                  v-bind:key="id.id"
                >
                  <div class="row-col-flex">
                    <h6>Type</h6>
                    <h5 class="caps">{{ id.type }}</h5>
                  </div>
                  <div class="row-col-flex">
                    <h6>ID No</h6>
                    <h5 class="caps">{{ id.idNo }}</h5>
                  </div>
                </div>
                <!-- arestee aliases -->
                <div
                  class="rows-flex green-border-top"
                  v-for="alias in arrestee.aliases"
                  v-bind:key="alias.id"
                >
                  <div class="row-col-flex">
                    <h6>Alias Name</h6>
                    <h5 class="caps">{{ alias.aliasName }}</h5>
                  </div>
                  <div class="row-col-flex">
                    <h6>Race</h6>
                    <h5 class="caps">{{ alias.race }}</h5>
                  </div>
                  <div class="row-col-flex">
                    <h6>Sex</h6>
                    <h5 class="caps">{{ alias.sex }}</h5>
                  </div>
                  <div class="row-col-flex">
                    <h6>DOB</h6>
                    <h5 class="caps">{{ alias.dob }}</h5>
                  </div>
                  <div class="row-col-flex">
                    <h6>Height</h6>
                    <h5 class="caps">{{ alias.height }}</h5>
                  </div>
                  <div class="row-col-flex">
                    <h6>Weight</h6>
                    <h5 class="caps">{{ alias.weight }}</h5>
                  </div>
                  <div class="row-col-flex">
                    <h6>Hair Color</h6>
                    <h5 class="caps">{{ alias.hairColor }}</h5>
                  </div>
                  <div class="row-col-flex">
                    <h6>Eye Color</h6>
                    <h5 class="caps">{{ alias.eyeColor }}</h5>
                  </div>
                </div>
                <!-- dispostition -->
                <div
                  class="rows-flex green-border-top"
                  v-for="dispo in arrestee.dispos"
                  v-bind:key="dispo.id"
                >
                  <div class="row-col-flex">
                    <h6>Involvement</h6>
                    <h5 class="caps">{{ dispo.involvement }}</h5>
                  </div>
                  <div class="row-col-flex">
                    <h6>Arrest Type</h6>
                    <h5 class="caps">{{ dispo.arrestType }}</h5>
                  </div>
                  <div class="row-col-flex">
                    <h6>Arrest Date</h6>
                    <h5 class="caps">{{ dispo.arrestDate }}</h5>
                  </div>
                  <div class="row-col-flex">
                    <h6>Arrest Time</h6>
                    <h5 class="caps">{{ dispo.arrestTime }}</h5>
                  </div>
                  <div class="row-col-flex">
                    <h6>Status</h6>
                    <h5 class="caps">{{ dispo.status }}</h5>
                  </div>
                  <div class="row-col-flex">
                    <h6>Dispo</h6>
                    <h5 class="caps">{{ dispo.dispo }}</h5>
                  </div>
                  <div class="row-col-flex">
                    <h6>Arrest Location</h6>
                    <h5 class="caps">{{ dispo.arrestLoc }}</h5>
                  </div>
                  <div class="row-col-flex">
                    <h6>City</h6>
                    <h5 class="caps">{{ dispo.city }}</h5>
                  </div>
                  <div class="row-col-flex">
                    <h6>Rep Dist</h6>
                    <h5 class="caps">{{ dispo.repDist }}</h5>
                  </div>
                  <div class="row-col-flex">
                    <h6>Place of Birth</h6>
                    <h5 class="caps">{{ dispo.birthPlace }}</h5>
                  </div>
                  <div class="row-col-flex">
                    <h6>Armed</h6>
                    <h5 class="caps">{{ dispo.armed }}</h5>
                  </div>
                  <div class="row-col-flex">
                    <h6>Multi-arrests</h6>
                    <h5 class="caps">{{ dispo.multiArrests }}</h5>
                  </div>
                  <div class="row-col-flex">
                    <h6>Beat</h6>
                    <h5 class="caps">{{ dispo.beat }}</h5>
                  </div>
                  <div class="row-col-flex">
                    <h6>NOC Charge</h6>
                    <h5 class="caps">{{ dispo.nocCharge }}</h5>
                  </div>
                  <div class="row-col-flex">
                    <h6>Level</h6>
                    <h5 class="caps">{{ dispo.level }}</h5>
                  </div>
                  <div class="row-col-flex">
                    <h6>Charge Literal</h6>
                    <h5 class="caps">{{ dispo.chargeLiteral }}</h5>
                  </div>
                  <div class="row-col-flex">
                    <h6>IBRS</h6>
                    <h5 class="caps">{{ dispo.ibrs }}</h5>
                  </div>
                  <div class="row-col-flex">
                    <h6>Arrrest NOC</h6>
                    <h5 class="caps">{{ dispo.arrrestNoc }}</h5>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <!-- CITED -->
        <div id="cited" v-for="cite in cited" v-bind:key="cite.id">
          <!-- HEADER -->
          <div class="content-header-labels">
            <div class="header-purple">
              <h4 class="caps">cited {{ cite.invlNum }}: {{ cite.name }}</h4>
            </div>
          </div>

          <!-- CONTENT -->
          <div class="content-header-labels">
            <div class="content-parent-flex">
              <div class="rows-flex">
                <div class="row-col-flex">
                  <h6>Involvement</h6>
                  <h5 class="caps">{{ cite.involvement }}</h5>
                </div>
                <div class="row-col-flex">
                  <h6>Invl No</h6>
                  <h5 class="caps">{{ cite.invlNum }}</h5>
                </div>
                <div class="row-col-flex">
                  <h6>Type</h6>
                  <h5 class="caps">{{ cite.type }}</h5>
                </div>
                <div class="row-col-flex">
                  <h6>Name</h6>
                  <h5 class="caps">{{ cite.name }}</h5>
                </div>
                <div class="row-col-flex">
                  <h6>MNI</h6>
                  <h5 class="caps">{{ cite.mni }}</h5>
                </div>
                <div class="row-col-flex">
                  <h6>Race</h6>
                  <h5 class="caps">{{ cite.race }}</h5>
                </div>
                <div class="row-col-flex">
                  <h6>Sex</h6>
                  <h5 class="caps">{{ cite.sex }}</h5>
                </div>
                <div class="row-col-flex">
                  <h6>DOB</h6>
                  <h5 class="caps">{{ cite.dob }}</h5>
                </div>
                <div class="row-col-flex">
                  <h6>Age</h6>
                  <h5 class="caps">{{ cite.age }}</h5>
                </div>
                <div class="row-col-flex">
                  <h6>Ethnicity</h6>
                  <h5 class="caps">{{ cite.ethnicity }}</h5>
                </div>
                <div class="row-col-flex">
                  <h6>Juvenile?</h6>
                  <h5 class="caps">{{ cite.juvenile }}</h5>
                </div>
                <div class="row-col-flex">
                  <h6>Height</h6>
                  <h5 class="caps">{{ cite.height }}</h5>
                </div>
                <div class="row-col-flex">
                  <h6>Weight</h6>
                  <h5 class="caps">{{ cite.weight }}</h5>
                </div>
                <div class="row-col-flex">
                  <h6>Hair Color</h6>
                  <h5 class="caps">{{ cite.hairColor }}</h5>
                </div>
                <div class="row-col-flex">
                  <h6>Eye Color</h6>
                  <h5 class="caps">{{ cite.eyeColor }}</h5>
                </div>
                <div class="row-col-flex">
                  <h6>Dom Violence?</h6>
                  <h5 class="caps">{{ cite.domViolence }}</h5>
                </div>
                <div class="row-col-flex">
                  <h6>Res Status</h6>
                  <h5 class="caps">{{ cite.resStatus }}</h5>
                </div>
                <div class="row-col-flex">
                  <h6>OFN_INVL</h6>
                  <h5 class="caps">{{ cite.ofnInvl }}</h5>
                </div>
                <div class="row-col-flex">
                  <h6>Vic/Ofnd Age</h6>
                  <h5 class="caps">{{ cite.vicOfndAge }}</h5>
                </div>
                <div class="row-col-flex">
                  <h6>PRN</h6>
                  <h5 class="caps">{{ cite.prn }}</h5>
                </div>
                <!-- cited addresses -->
                <div
                  class="rows-flex green-border-top"
                  v-for="address in cite.addresses"
                  v-bind:key="address.id"
                >
                  <div class="row-col-flex">
                    <h6>Type</h6>
                    <h5 class="caps">{{ address.type }}</h5>
                  </div>
                  <div class="row-col-flex">
                    <h6>Address</h6>
                    <h5 class="caps">{{ address.address }}</h5>
                  </div>
                  <div class="row-col-flex">
                    <h6>City</h6>
                    <h5 class="caps">{{ address.city }}</h5>
                  </div>
                  <div class="row-col-flex">
                    <h6>State</h6>
                    <h5 class="caps">{{ address.state }}</h5>
                  </div>
                  <div class="row-col-flex">
                    <h6>Zip Code</h6>
                    <h5 class="caps">{{ address.zipCode }}</h5>
                  </div>
                  <div class="row-col-flex">
                    <h6>Date</h6>
                    <h5 class="caps">{{ address.date }}</h5>
                  </div>
                </div>
                <!-- cite ids -->
                <div
                  class="rows-flex green-border-top"
                  v-for="id in cite.ids"
                  v-bind:key="id.id"
                >
                  <div class="row-col-flex">
                    <h6>Type</h6>
                    <h5 class="caps">{{ id.type }}</h5>
                  </div>
                  <div class="row-col-flex">
                    <h6>ID No</h6>
                    <h5 class="caps">{{ id.idNo }}</h5>
                  </div>
                </div>
                <!-- cite aliases -->
                <div
                  class="rows-flex green-border-top"
                  v-for="alias in cite.aliases"
                  v-bind:key="alias.id"
                >
                  <div class="row-col-flex">
                    <h6>Alias Name</h6>
                    <h5 class="caps">{{ alias.aliasName }}</h5>
                  </div>
                  <div class="row-col-flex">
                    <h6>Race</h6>
                    <h5 class="caps">{{ alias.race }}</h5>
                  </div>
                  <div class="row-col-flex">
                    <h6>Sex</h6>
                    <h5 class="caps">{{ alias.sex }}</h5>
                  </div>
                  <div class="row-col-flex">
                    <h6>DOB</h6>
                    <h5 class="caps">{{ alias.dob }}</h5>
                  </div>
                  <div class="row-col-flex">
                    <h6>Height</h6>
                    <h5 class="caps">{{ alias.height }}</h5>
                  </div>
                  <div class="row-col-flex">
                    <h6>Weight</h6>
                    <h5 class="caps">{{ alias.weight }}</h5>
                  </div>
                  <div class="row-col-flex">
                    <h6>Hair Color</h6>
                    <h5 class="caps">{{ alias.hairColor }}</h5>
                  </div>
                  <div class="row-col-flex">
                    <h6>Eye Color</h6>
                    <h5 class="caps">{{ alias.eyeColor }}</h5>
                  </div>
                </div>
                <!-- dispostition -->
                <div
                  class="rows-flex green-border-top"
                  v-for="dispo in cite.dispos"
                  v-bind:key="dispo.id"
                >
                  <div class="row-col-flex">
                    <h6>Involvement</h6>
                    <h5 class="caps">{{ dispo.involvement }}</h5>
                  </div>
                  <div class="row-col-flex">
                    <h6>Arrest Type</h6>
                    <h5 class="caps">{{ dispo.arrestType }}</h5>
                  </div>
                  <div class="row-col-flex">
                    <h6>Arrest Date</h6>
                    <h5 class="caps">{{ dispo.arrestDate }}</h5>
                  </div>
                  <div class="row-col-flex">
                    <h6>Arrest Time</h6>
                    <h5 class="caps">{{ dispo.arrestTime }}</h5>
                  </div>
                  <div class="row-col-flex">
                    <h6>Status</h6>
                    <h5 class="caps">{{ dispo.status }}</h5>
                  </div>
                  <div class="row-col-flex">
                    <h6>Dispo</h6>
                    <h5 class="caps">{{ dispo.dispo }}</h5>
                  </div>
                  <div class="row-col-flex">
                    <h6>Arrest Location</h6>
                    <h5 class="caps">{{ dispo.arrestLoc }}</h5>
                  </div>
                  <div class="row-col-flex">
                    <h6>City</h6>
                    <h5 class="caps">{{ dispo.city }}</h5>
                  </div>
                  <div class="row-col-flex">
                    <h6>Rep Dist</h6>
                    <h5 class="caps">{{ dispo.repDist }}</h5>
                  </div>
                  <div class="row-col-flex">
                    <h6>Place of Birth</h6>
                    <h5 class="caps">{{ dispo.birthPlace }}</h5>
                  </div>
                  <div class="row-col-flex">
                    <h6>Armed</h6>
                    <h5 class="caps">{{ dispo.armed }}</h5>
                  </div>
                  <div class="row-col-flex">
                    <h6>Multi-arrests</h6>
                    <h5 class="caps">{{ dispo.multiArrests }}</h5>
                  </div>
                  <div class="row-col-flex">
                    <h6>Beat</h6>
                    <h5 class="caps">{{ dispo.beat }}</h5>
                  </div>
                  <div class="row-col-flex">
                    <h6>NOC Charge</h6>
                    <h5 class="caps">{{ dispo.nocCharge }}</h5>
                  </div>
                  <div class="row-col-flex">
                    <h6>Level</h6>
                    <h5 class="caps">{{ dispo.level }}</h5>
                  </div>
                  <div class="row-col-flex">
                    <h6>Charge Literal</h6>
                    <h5 class="caps">{{ dispo.chargeLiteral }}</h5>
                  </div>
                  <div class="row-col-flex">
                    <h6>IBRS</h6>
                    <h5 class="caps">{{ dispo.ibrs }}</h5>
                  </div>
                  <div class="row-col-flex">
                    <h6>Arrrest NOC</h6>
                    <h5 class="caps">{{ dispo.arrrestNoc }}</h5>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <!-- SUBJECT -->
        <div id="subject" v-for="subject in subjects" v-bind:key="subject.id">
          <!-- HEADER -->
          <div class="content-header-labels">
            <div class="header-purple">
              <h4 class="caps">
                subject {{ subject.invlNum }}: {{ subject.name }}
              </h4>
            </div>
          </div>

          <!-- CONTENT -->
          <div class="content-header-labels">
            <div class="content-parent-flex">
              <div class="rows-flex">
                <div class="row-col-flex">
                  <h6>Involvement</h6>
                  <h5 class="caps">{{ subject.involvement }}</h5>
                </div>
                <div class="row-col-flex">
                  <h6>Invl No</h6>
                  <h5 class="caps">{{ subject.invlNum }}</h5>
                </div>
                <div class="row-col-flex">
                  <h6>Type</h6>
                  <h5 class="caps">{{ subject.type }}</h5>
                </div>
                <div class="row-col-flex">
                  <h6>Name</h6>
                  <h5 class="caps">{{ subject.name }}</h5>
                </div>
                <div class="row-col-flex">
                  <h6>MNI</h6>
                  <h5 class="caps">{{ subject.mni }}</h5>
                </div>
                <div class="row-col-flex">
                  <h6>Race</h6>
                  <h5 class="caps">{{ subject.race }}</h5>
                </div>
                <div class="row-col-flex">
                  <h6>Sex</h6>
                  <h5 class="caps">{{ subject.sex }}</h5>
                </div>
                <div class="row-col-flex">
                  <h6>DOB</h6>
                  <h5 class="caps">{{ subject.dob }}</h5>
                </div>
                <div class="row-col-flex">
                  <h6>Age</h6>
                  <h5 class="caps">{{ subject.age }}</h5>
                </div>
                <div class="row-col-flex">
                  <h6>Ethnicity</h6>
                  <h5 class="caps">{{ subject.ethnicity }}</h5>
                </div>
                <div class="row-col-flex">
                  <h6>Juvenile?</h6>
                  <h5 class="caps">{{ subject.juvenile }}</h5>
                </div>
                <div class="row-col-flex">
                  <h6>Height</h6>
                  <h5 class="caps">{{ subject.height }}</h5>
                </div>
                <div class="row-col-flex">
                  <h6>Weight</h6>
                  <h5 class="caps">{{ subject.weight }}</h5>
                </div>
                <div class="row-col-flex">
                  <h6>Hair Color</h6>
                  <h5 class="caps">{{ subject.hairColor }}</h5>
                </div>
                <div class="row-col-flex">
                  <h6>Eye Color</h6>
                  <h5 class="caps">{{ subject.eyeColor }}</h5>
                </div>
                <div class="row-col-flex">
                  <h6>Dom Violence?</h6>
                  <h5 class="caps">{{ subject.domViolence }}</h5>
                </div>
                <div class="row-col-flex">
                  <h6>Res Status</h6>
                  <h5 class="caps">{{ subject.resStatus }}</h5>
                </div>
                <div class="row-col-flex">
                  <h6>OFN_INVL</h6>
                  <h5 class="caps">{{ subject.ofnInvl }}</h5>
                </div>
                <div class="row-col-flex">
                  <h6>Vic/Ofnd Age</h6>
                  <h5 class="caps">{{ subject.vicOfndAge }}</h5>
                </div>
                <div class="row-col-flex">
                  <h6>PRN</h6>
                  <h5 class="caps">{{ subject.prn }}</h5>
                </div>
                <!-- subjects addresses -->
                <div
                  class="rows-flex green-border-top"
                  v-for="address in subject.addresses"
                  v-bind:key="address.id"
                >
                  <div class="row-col-flex">
                    <h6>Type</h6>
                    <h5 class="caps">{{ address.type }}</h5>
                  </div>
                  <div class="row-col-flex">
                    <h6>Address</h6>
                    <h5 class="caps">{{ address.address }}</h5>
                  </div>
                  <div class="row-col-flex">
                    <h6>City</h6>
                    <h5 class="caps">{{ address.city }}</h5>
                  </div>
                  <div class="row-col-flex">
                    <h6>State</h6>
                    <h5 class="caps">{{ address.state }}</h5>
                  </div>
                  <div class="row-col-flex">
                    <h6>Zip Code</h6>
                    <h5 class="caps">{{ address.zipCode }}</h5>
                  </div>
                  <div class="row-col-flex">
                    <h6>Date</h6>
                    <h5 class="caps">{{ address.date }}</h5>
                  </div>
                </div>
                <!-- subject ids -->
                <div
                  class="rows-flex green-border-top"
                  v-for="id in subject.ids"
                  v-bind:key="id.id"
                >
                  <div class="row-col-flex">
                    <h6>Type</h6>
                    <h5 class="caps">{{ id.type }}</h5>
                  </div>
                  <div class="row-col-flex">
                    <h6>ID No</h6>
                    <h5 class="caps">{{ id.idNo }}</h5>
                  </div>
                </div>
                <!-- subject aliases -->
                <div
                  class="rows-flex green-border-top"
                  v-for="alias in subject.aliases"
                  v-bind:key="alias.id"
                >
                  <div class="row-col-flex">
                    <h6>Alias Name</h6>
                    <h5 class="caps">{{ alias.aliasName }}</h5>
                  </div>
                  <div class="row-col-flex">
                    <h6>Race</h6>
                    <h5 class="caps">{{ alias.race }}</h5>
                  </div>
                  <div class="row-col-flex">
                    <h6>Sex</h6>
                    <h5 class="caps">{{ alias.sex }}</h5>
                  </div>
                  <div class="row-col-flex">
                    <h6>DOB</h6>
                    <h5 class="caps">{{ alias.dob }}</h5>
                  </div>
                  <div class="row-col-flex">
                    <h6>Height</h6>
                    <h5 class="caps">{{ alias.height }}</h5>
                  </div>
                  <div class="row-col-flex">
                    <h6>Weight</h6>
                    <h5 class="caps">{{ alias.weight }}</h5>
                  </div>
                  <div class="row-col-flex">
                    <h6>Hair Color</h6>
                    <h5 class="caps">{{ alias.hairColor }}</h5>
                  </div>
                  <div class="row-col-flex">
                    <h6>Eye Color</h6>
                    <h5 class="caps">{{ alias.eyeColor }}</h5>
                  </div>
                </div>
                <!-- subject dispostition -->
                <div
                  class="rows-flex green-border-top"
                  v-for="dispo in subject.dispos"
                  v-bind:key="dispo.id"
                >
                  <div class="row-col-flex">
                    <h6>Involvement</h6>
                    <h5 class="caps">{{ dispo.involvement }}</h5>
                  </div>
                  <div class="row-col-flex">
                    <h6>Arrest Type</h6>
                    <h5 class="caps">{{ dispo.arrestType }}</h5>
                  </div>
                  <div class="row-col-flex">
                    <h6>Arrest Date</h6>
                    <h5 class="caps">{{ dispo.arrestDate }}</h5>
                  </div>
                  <div class="row-col-flex">
                    <h6>Arrest Time</h6>
                    <h5 class="caps">{{ dispo.arrestTime }}</h5>
                  </div>
                  <div class="row-col-flex">
                    <h6>Status</h6>
                    <h5 class="caps">{{ dispo.status }}</h5>
                  </div>
                  <div class="row-col-flex">
                    <h6>Dispo</h6>
                    <h5 class="caps">{{ dispo.dispo }}</h5>
                  </div>
                  <div class="row-col-flex">
                    <h6>Arrest Location</h6>
                    <h5 class="caps">{{ dispo.arrestLoc }}</h5>
                  </div>
                  <div class="row-col-flex">
                    <h6>City</h6>
                    <h5 class="caps">{{ dispo.city }}</h5>
                  </div>
                  <div class="row-col-flex">
                    <h6>Rep Dist</h6>
                    <h5 class="caps">{{ dispo.repDist }}</h5>
                  </div>
                  <div class="row-col-flex">
                    <h6>Place of Birth</h6>
                    <h5 class="caps">{{ dispo.birthPlace }}</h5>
                  </div>
                  <div class="row-col-flex">
                    <h6>Armed</h6>
                    <h5 class="caps">{{ dispo.armed }}</h5>
                  </div>
                  <div class="row-col-flex">
                    <h6>Multi-arrests</h6>
                    <h5 class="caps">{{ dispo.multiArrests }}</h5>
                  </div>
                  <div class="row-col-flex">
                    <h6>Beat</h6>
                    <h5 class="caps">{{ dispo.beat }}</h5>
                  </div>
                  <div class="row-col-flex">
                    <h6>NOC Charge</h6>
                    <h5 class="caps">{{ dispo.nocCharge }}</h5>
                  </div>
                  <div class="row-col-flex">
                    <h6>Level</h6>
                    <h5 class="caps">{{ dispo.level }}</h5>
                  </div>
                  <div class="row-col-flex">
                    <h6>Charge Literal</h6>
                    <h5 class="caps">{{ dispo.chargeLiteral }}</h5>
                  </div>
                  <div class="row-col-flex">
                    <h6>IBRS</h6>
                    <h5 class="caps">{{ dispo.ibrs }}</h5>
                  </div>
                  <div class="row-col-flex">
                    <h6>Arrrest NOC</h6>
                    <h5 class="caps">{{ dispo.arrrestNoc }}</h5>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <!-- LAW ENFORCEMENT -->
        <div id="cops" v-for="cop in cops" v-bind:key="cop.id">
          <!-- HEADER -->
          <div class="content-header-labels">
            <div class="header-purple">
              <h4 class="caps">
                Law Enforcement personnel {{ cop.invlNum }}: {{ cop.name }}
              </h4>
            </div>
          </div>

          <!-- CONTENT -->
          <div id="" class="content-header-labels">
            <div class="content-parent-flex">
              <div class="rows-flex">
                <div class="row-col-flex">
                  <h6>Involvement</h6>
                  <h5 class="caps">{{ cop.involvement }}</h5>
                </div>
                <div class="row-col-flex">
                  <h6>Inv lNum</h6>
                  <h5 class="caps">{{ cop.invlNum }}</h5>
                </div>
                <div class="row-col-flex">
                  <h6>Type</h6>
                  <h5 class="caps">{{ cop.type }}</h5>
                </div>
                <div class="row-col-flex">
                  <h6>Name</h6>
                  <h5 class="caps">{{ cop.name }}</h5>
                </div>
                <div class="row-col-flex">
                  <h6>PRN</h6>
                  <h5 class="caps">{{ cop.prn }}</h5>
                </div>
              </div>
            </div>
          </div>
        </div>

        <!-- VICTIMS -->
        <div id="victims" v-for="victim in victims" v-bind:key="victim.id">
          <!-- HEADER -->
          <div class="content-header-labels">
            <div class="header-purple">
              <h4 class="caps">
                Victim {{ victim.invlNum }}: {{ victim.name }}
              </h4>
            </div>
          </div>

          <!-- CONTENT -->
          <div id="" class="content-header-labels">
            <div class="content-parent-flex">
              <div class="rows-flex">
                <div class="row-col-flex">
                  <h6>Involvement</h6>
                  <h5 class="caps">{{ victim.involvement }}</h5>
                </div>
                <div class="row-col-flex">
                  <h6>Invl No</h6>
                  <h5 class="caps">{{ victim.invlNum }}</h5>
                </div>
                <div class="row-col-flex">
                  <h6>Type</h6>
                  <h5 class="caps">{{ victim.type }}</h5>
                </div>
                <div class="row-col-flex">
                  <h6>Name</h6>
                  <h5 class="caps">{{ victim.name }}</h5>
                </div>
                <div class="row-col-flex">
                  <h6>MNI</h6>
                  <h5 class="caps">{{ victim.mni }}</h5>
                </div>
                <div class="row-col-flex">
                  <h6>Race</h6>
                  <h5 class="caps">{{ victim.race }}</h5>
                </div>
                <div class="row-col-flex">
                  <h6>Sex</h6>
                  <h5 class="caps">{{ victim.sex }}</h5>
                </div>
                <div class="row-col-flex">
                  <h6>Ethnicity</h6>
                  <h5 class="caps">{{ victim.ethnicity }}</h5>
                </div>
                <div class="row-col-flex">
                  <h6>Means of Attack</h6>
                  <h5 class="caps">{{ victim.attack }}</h5>
                </div>
                <div class="row-col-flex">
                  <h6>Extent of Injury</h6>
                  <h5 class="caps">{{ victim.injury }}</h5>
                </div>
                <div class="row-col-flex">
                  <h6>Dom Violence</h6>
                  <h5 class="caps">{{ victim.domViolence }}</h5>
                </div>
                <div class="row-col-flex">
                  <h6>Res Status</h6>
                  <h5 class="caps">{{ victim.resStatus }}</h5>
                </div>
                <div class="row-col-flex">
                  <h6>Vic/Ofn Age</h6>
                  <h5 class="caps">{{ victim.vicOfnAge }}</h5>
                </div>
                <div class="row-col-flex">
                  <h6>PRN</h6>
                  <h5 class="caps">{{ victim.prn }}</h5>
                </div>
              </div>
            </div>
          </div>
          <!-- IBRS -->
          <div v-for="ibrs in victim.ibrses" v-bind:key="ibrs.id">
            <!-- HEADER -->
            <div class="content-header-labels">
              <div class="header-green">
                <h4 class="caps">IBRS Info</h4>
              </div>
            </div>
            <!-- CONTENT -->
            <div id="" class="content-header-labels">
              <div class="content-parent-flex">
                <div class="rows-flex">
                  <div class="row-col-flex">
                    <h6>Victim Invl No</h6>
                    <h5 class="caps">{{ ibrs.vicInvlNo }}</h5>
                  </div>
                  <div class="row-col-flex">
                    <h6>Offense Codes</h6>
                    <h5 class="caps">{{ ibrs.offCodes }}</h5>
                  </div>
                  <div class="row-col-flex">
                    <h6>Injury</h6>
                    <h5 class="caps">{{ ibrs.injury }}</h5>
                  </div>
                  <div class="row-col-flex">
                    <h6>Rel</h6>
                    <h5 class="caps">{{ ibrs.rel }}</h5>
                  </div>
                  <div class="row-col-flex">
                    <h6>Involvement</h6>
                    <h5 class="caps">{{ ibrs.involvement }}</h5>
                  </div>
                  <div class="row-col-flex">
                    <h6>Invl No</h6>
                    <h5 class="caps">{{ ibrs.invlNo }}</h5>
                  </div>
                  <div class="row-col-flex">
                    <h6>Name</h6>
                    <h5 class="caps">{{ ibrs.name }}</h5>
                  </div>
                  <div class="row-col-flex">
                    <h6>Race</h6>
                    <h5 class="caps">{{ ibrs.race }}</h5>
                  </div>
                  <div class="row-col-flex">
                    <h6>Sex</h6>
                    <h5 class="caps">{{ ibrs.sex }}</h5>
                  </div>
                  <div class="row-col-flex">
                    <h6>DOB</h6>
                    <h5 class="caps">{{ ibrs.dob }}</h5>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <!-- WITNESSES -->
        <div
          id="witnesses"
          v-for="witness in witnesses"
          v-bind:key="witness.id"
        >
          <!-- HEADER -->
          <div class="content-header-labels">
            <div class="header-purple">
              <h4 class="caps">
                Witness {{ witness.invlNum }}: {{ witness.name }}
              </h4>
            </div>
          </div>

          <!-- CONTENT -->
          <div class="content-header-labels">
            <div class="content-parent-flex">
              <div class="rows-flex">
                <div class="row-col-flex">
                  <h6>Involvement</h6>
                  <h5 class="caps">{{ witness.involvement }}</h5>
                </div>
                <div class="row-col-flex">
                  <h6>Invl No</h6>
                  <h5 class="caps">{{ witness.invlNum }}</h5>
                </div>
                <div class="row-col-flex">
                  <h6>Type</h6>
                  <h5 class="caps">{{ witness.type }}</h5>
                </div>
                <div class="row-col-flex">
                  <h6>Name</h6>
                  <h5 class="caps">{{ witness.name }}</h5>
                </div>
                <div class="row-col-flex">
                  <h6>MNI</h6>
                  <h5 class="caps">{{ witness.mni }}</h5>
                </div>
                <div class="row-col-flex">
                  <h6>Race</h6>
                  <h5 class="caps">{{ witness.race }}</h5>
                </div>
                <div class="row-col-flex">
                  <h6>Sex</h6>
                  <h5 class="caps">{{ witness.sex }}</h5>
                </div>
                <div class="row-col-flex">
                  <h6>DOB</h6>
                  <h5 class="caps">{{ witness.dob }}</h5>
                </div>
                <div class="row-col-flex">
                  <h6>Age</h6>
                  <h5 class="caps">{{ witness.age }}</h5>
                </div>
                <div class="row-col-flex">
                  <h6>Ethnicity</h6>
                  <h5 class="caps">{{ witness.ethnicity }}</h5>
                </div>
                <div class="row-col-flex">
                  <h6>Juvenile?</h6>
                  <h5 class="caps">{{ witness.juvenile }}</h5>
                </div>
                <div class="row-col-flex">
                  <h6>Height</h6>
                  <h5 class="caps">{{ witness.height }}</h5>
                </div>
                <div class="row-col-flex">
                  <h6>Weight</h6>
                  <h5 class="caps">{{ witness.weight }}</h5>
                </div>
                <div class="row-col-flex">
                  <h6>Hair Color</h6>
                  <h5 class="caps">{{ witness.hairColor }}</h5>
                </div>
                <div class="row-col-flex">
                  <h6>Eye Color</h6>
                  <h5 class="caps">{{ witness.eyeColor }}</h5>
                </div>
                <div class="row-col-flex">
                  <h6>PRN</h6>
                  <h5 class="caps">{{ witness.prn }}</h5>
                </div>
                <!-- witness address -->
                <div
                  class="rows-flex green-border-top"
                  v-for="address in witness.addresses"
                  v-bind:key="address.id"
                >
                  <div class="row-col-flex">
                    <h6>Type</h6>
                    <h5 class="caps">{{ address.type }}</h5>
                  </div>
                  <div class="row-col-flex">
                    <h6>Address</h6>
                    <h5 class="caps">{{ address.address }}</h5>
                  </div>
                  <div class="row-col-flex">
                    <h6>City</h6>
                    <h5 class="caps">{{ address.city }}</h5>
                  </div>
                  <div class="row-col-flex">
                    <h6>State</h6>
                    <h5 class="caps">{{ address.state }}</h5>
                  </div>
                  <div class="row-col-flex">
                    <h6>Zip Code</h6>
                    <h5 class="caps">{{ address.zipCode }}</h5>
                  </div>
                  <div class="row-col-flex">
                    <h6>Date</h6>
                    <h5 class="caps">{{ address.date }}</h5>
                  </div>
                </div>
                <!-- witness ids -->
                <div
                  class="rows-flex green-border-top"
                  v-for="id in witness.ids"
                  v-bind:key="id.id"
                >
                  <div class="row-col-flex">
                    <h6>Type</h6>
                    <h5 class="caps">{{ id.type }}</h5>
                  </div>
                  <div class="row-col-flex">
                    <h6>ID No</h6>
                    <h5 class="caps">{{ id.idNo }}</h5>
                  </div>
                </div>
                <div
                  class="rows-flex green-border-top"
                  v-for="phone in witness.phones"
                  v-bind:key="phone.id"
                >
                  <div class="row-col-flex">
                    <h6>Phone Type</h6>
                    <h5 class="caps">{{ phone.phoneType }}</h5>
                  </div>
                  <div class="row-col-flex">
                    <h6>Phone No</h6>
                    <h5 class="caps">{{ phone.phoneNo }}</h5>
                  </div>
                  <div class="row-col-flex">
                    <h6>Date</h6>
                    <h5 class="caps">{{ phone.date }}</h5>
                  </div>
                  <div
                    class="rows-flex green-border-top"
                    v-for="phone in witness.phones"
                    v-bind:key="phone.id"
                  >
                    <div class="row-col-flex">
                      <h6>Employer/School</h6>
                      <h5 class="caps">{{ phone.empSchool }}</h5>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <!-- PROPERTY -->
        <div
          id="property"
          v-for="property in properties"
          v-bind:key="property.id"
        >
          <!-- HEADER -->
          <div class="content-header-labels">
            <div class="header-orange">
              <h4 class="caps">Property {{ property.propNum }}</h4>
            </div>
          </div>

          <!-- CONTENT -->
          <div class="content-header-labels">
            <div class="content-parent-flex">
              <div class="rows-flex">
                <div class="row-col-flex">
                  <h6>prop #</h6>
                  <h5 class="caps">{{ property.propNum }}</h5>
                </div>
                <div class="row-col-flex">
                  <h6>involvement</h6>
                  <h5 class="caps">{{ property.invl1 }}</h5>
                </div>
                <div class="row-col-flex">
                  <h6>Invl Date</h6>
                  <h5 class="caps">{{ property.invlDate }}</h5>
                </div>
                <div class="row-col-flex">
                  <h6>In Custody?</h6>
                  <h5 class="caps">{{ property.inCust }}</h5>
                </div>
                <div class="row-col-flex">
                  <h6>Security</h6>
                  <h5 class="caps">{{ property.security }}</h5>
                </div>
                <div class="row-col-flex">
                  <h6>Bar Code</h6>
                  <h5 class="caps">{{ property.barCode }}</h5>
                </div>
                <div class="row-col-flex">
                  <h6>Item No</h6>
                  <h5 class="caps">{{ property.itemNo }}</h5>
                </div>
                <div class="row-col-flex">
                  <h6>Description</h6>
                  <h5 class="caps">{{ property.description }}</h5>
                </div>
                <div class="row-col-flex">
                  <h6>Typ</h6>
                  <h5 class="caps">{{ property.typ }}</h5>
                </div>
                <div class="row-col-flex">
                  <h6>Cat</h6>
                  <h5 class="caps">{{ property.cat }}</h5>
                </div>
                <div class="row-col-flex">
                  <h6>Article</h6>
                  <h5 class="caps">{{ property.article }}</h5>
                </div>
                <div class="row-col-flex">
                  <h6>IBRS Type</h6>
                  <h5 class="caps">{{ property.ibrsType }}</h5>
                </div>
                <div class="row-col-flex">
                  <h6>Rcv Location</h6>
                  <h5 class="caps">{{ property.rcvLoc }}</h5>
                </div>
                <div class="row-col-flex">
                  <h6>Rcv City</h6>
                  <h5 class="caps">{{ property.rcvCity }}</h5>
                </div>
                <div class="row-col-flex">
                  <h6>Rcv St</h6>
                  <h5 class="caps">{{ property.rcvSt }}</h5>
                </div>
                <div class="row-col-flex">
                  <h6>Rep Dist</h6>
                  <h5 class="caps">{{ property.repDist }}</h5>
                </div>
                <div class="row-col-flex">
                  <h6>Beat</h6>
                  <h5 class="caps">{{ property.beat }}</h5>
                </div>
                <div class="row-col-flex">
                  <h6>Area</h6>
                  <h5 class="caps">{{ property.area }}</h5>
                </div>
                <div class="row-col-flex">
                  <h6>Entered Date</h6>
                  <h5 class="caps">{{ property.enteredDate }}</h5>
                </div>
                <div class="row-col-flex">
                  <h6>Entered Time</h6>
                  <h5 class="caps">{{ property.enteredTime }}</h5>
                </div>
                <div class="row-col-flex">
                  <h6>RMS Transfer</h6>
                  <h5 class="caps">{{ property.rmsTransfer }}</h5>
                </div>
                <div class="row-col-flex">
                  <h6>Control</h6>
                  <h5 class="caps">{{ property.control }}</h5>
                </div>
                <div class="row-col-flex">
                  <h6>Link</h6>
                  <h5 class="caps">{{ property.link }}</h5>
                </div>
                <div class="row-col-flex">
                  <h6>Involvement</h6>
                  <h5 class="caps">{{ property.invl2 }}</h5>
                </div>
                <div class="row-col-flex">
                  <h6>Invl No</h6>
                  <h5 class="caps">{{ property.invlNo }}</h5>
                </div>
                <div class="row-col-flex">
                  <h6>Name</h6>
                  <h5 class="caps">{{ property.name }}</h5>
                </div>
                <div class="row-col-flex">
                  <h6>Race</h6>
                  <h5 class="caps">{{ property.race }}</h5>
                </div>
                <div class="row-col-flex">
                  <h6>Sex</h6>
                  <h5 class="caps">{{ property.sex }}</h5>
                </div>
                <div class="row-col-flex">
                  <h6>DOB</h6>
                  <h5 class="caps">{{ property.dob }}</h5>
                </div>
              </div>
            </div>
          </div>
        </div>

        <!-- MODUS OPERANDI -->
        <div id="" v-for="modOp in modOps" v-bind:key="modOp.id">
          <!-- HEADER -->
          <div class="content-header-labels">
            <div class="header-green">
              <h4 class="caps">modus operandi</h4>
            </div>
          </div>

          <!-- CONTENT -->
          <div id="" class="content-header-labels">
            <div class="content-parent-flex">
              <div class="rows-flex">
                <div class="row-col-flex">
                  <h6>Physical Evidence</h6>
                  <h5 class="caps">{{ modOp.physEv }}</h5>
                </div>
                <div class="row-col-flex">
                  <h6>Weapon Used</h6>
                  <h5 class="caps">{{ modOp.weaponUsed }}</h5>
                </div>
                <div class="row-col-flex">
                  <h6>Premise Type</h6>
                  <h5 class="caps">{{ modOp.premType }}</h5>
                </div>
                <div class="row-col-flex">
                  <h6>Crime Code(s)</h6>
                  <h5 class="caps">{{ modOp.crimeCode }}</h5>
                </div>
              </div>
            </div>
          </div>
        </div>

        <!-- NARRATIVE -->
        <div
          id="narrative"
          v-for="narrative in narratives"
          v-bind:key="narrative.id"
        >
          <!-- HEADER -->
          <div class="content-header-labels">
            <div class="header-red">
              <h4 class="caps">narrative</h4>
            </div>
          </div>

          <!-- CONTENT -->
          <div id="" class="content-header-labels">
            <div class="content-parent-flex">
              <div class="rows-flex">
                <div class="row-col-flex">
                  <h6></h6>
                  <h5 class="">{{ narrative.narrDescript }}</h5>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  </div>
</template>

<style lang="scss" scoped>
// @import "../scss/styles.scss";

/* 0 media q*/

@media only screen and (min-width: 0) {
  .bottom-pad {
    padding-bottom: 50px;
  }
  .caps {
    text-transform: uppercase;
  }
  .content-header {
    background-color: white;
    padding: 0 0.5in 15px 0.5in;
  }
  .content-header-labels {
    background-color: white;
    padding: 0 0.5in;
  }
  .flex-1 {
    display: -webkit-flex;
    display: flex;
    -webkit-flex-direction: row;
    flex-direction: row;
    -webkit-flex-wrap: nowrap;
    flex-wrap: nowrap;
    -webkit-justify-content: space-between;
    justify-content: space-between;
    -webkit-align-items: center;
    align-items: center;
  }

  .flex-2-main {
    display: -webkit-flex;
    display: flex;
    -webkit-flex-direction: row;
    flex-direction: row;
    -webkit-flex-wrap: nowrap;
    flex-wrap: nowrap;
    -webkit-justify-content: space-between;
    justify-content: space-between;
    -webkit-align-items: flex-start;
    align-items: flex-start;
  }
  .flex-child-1 {
    display: -webkit-flex;
    display: flex;
    -webkit-flex-direction: column;
    flex-direction: column;
    -webkit-flex-wrap: nowrap;
    flex-wrap: nowrap;
    -webkit-justify-content: flex-start;
    justify-content: flex-start;
    -webkit-align-items: flex-start;
    align-items: flex-start;
  }

  .badge {
    padding-right: 20px;
  }

  .address {
    flex-grow: 2;
  }

  .header-purple {
    width: 100%;
    color: aliceblue;
    background-color: #800080;
  }

  .header-orange {
    color: aliceblue;
    background-color: #fd803e;
  }

  .header-green {
    color: aliceblue;
    background-color: #008000;
  }

  .header-red {
    color: aliceblue;
    background-color: #800000;
  }

  .content {
    background-color: white;
    padding: 0 0.5in;
    padding-bottom: 0.5in;
  }

  #home {
    margin-top: 42px;
  }

  #cops .content-header-labels h4 {
    max-width: 90%;
    font-size: 1.1rem;
  }
  /* HEADING STYLES */
  #home h3 {
    padding-top: 10px;
    margin-left: 0;
    font-weight: 400;
    margin-bottom: 0;
  }
  #home h4 {
    margin-left: 5px;
    font-weight: 600;
    margin-bottom: 0;
  }

  #home h5 {
    margin-bottom: 0;
    padding-top: 0;
    line-height: 1rem;
  }

  #home h6 {
    margin-bottom: 0;
    font-style: normal;
    padding-top: 0;
    font-weight: 400;
  }

  /*   #home .admin-info h5 {
    } */

  #home .address h5 {
    line-height: 1.5rem;
  }

  #home .date-type h5 {
    line-height: 1.2rem;
  }
  /* END HEADING STYLES */

  /* MAIN CONTENT */
  .content-parent-flex {
    width: 100%;
    display: -webkit-flex;
    display: flex;
    -webkit-flex-direction: column;
    flex-direction: column;
    -webkit-flex-wrap: nowrap;
    flex-wrap: nowrap;
    -webkit-justify-content: flex-start;
    justify-content: flex-start;
    -webkit-align-items: flex-start;
    align-items: flex-start;
  }

  .rows-flex {
    width: 100%;
    display: -webkit-flex;
    display: flex;
    -webkit-flex-direction: row;
    flex-direction: row;
    -webkit-flex-wrap: wrap;
    flex-wrap: wrap;
    -webkit-justify-content: flex-start;
    justify-content: flex-start;
    -webkit-align-items: center;
    align-items: center;
  }
  .row-col-flex {
    flex-grow: 1;
    flex-basis: auto;
    display: -webkit-flex;
    display: flex;
    -webkit-flex-direction: column;
    flex-direction: column;
    -webkit-flex-wrap: nowrap;
    flex-wrap: nowrap;
    -webkit-justify-content: flex-start;
    justify-content: flex-start;
    -webkit-align-items: flex-start;
    align-items: flex-start;
    border: 1px solid black;
    /* border-width: 0 0 1px 2px; */
    padding: 0 10px;
    min-height: 42px;
  }

  .green-border-top {
    border-top: 2px #008000 solid;
  }

  .perscell1,
  .perscell3,
  .perscell5,
  .perscell6 {
    width: 4%;
  }

  .perscell2,
  .perscell7 {
    width: 12%;
  }

  .perscell4 {
    width: 23%;
  }

  .propcell1 {
    width: 12%;
  }

  .propcell2 {
    width: 66%;
  }

  #narrative {
    padding-bottom: 50px;
    background-color: white;
  }

  #narrative h5 {
    padding: 15px 0;
    max-width: unset;
    width: 95%;
  }

  ::-webkit-input-placeholder {
    /* Chrome/Opera/Safari */
    color: white;
    font-weight: 500;
  }
}

@media print {
  #home {
    width: 100%;
    padding: 0;
    margin: 0;
  }

  @page {
    margin: 0.5in;
  }
}

@media only screen and (min-width: 375px) {
}

@media only screen and (min-width: 461px) {
}

/*768 media q*/
@media only screen and (min-width: 768px) {
}
/* 993 media q*/
@media only screen and (min-width: 993px) {
}

/* 1025 media q - DELETE all this after template export*/
@media only screen and (min-width: 1025px) {
}
</style>

<script>
/*eslint-disable*/
//v. 1.055
//import VueHtml2pdf from "vue-html2pdf";

export default {
  name: "printx",
  data() {
    return {
      header_main: [
        {
          id: "mainHeader",
          casenum: "22-4537",
          rep_date: "03/08/2022",
          inc_type: "weapons",
        },
      ],

      /* admin content */
      admin_content: [
        {
          id: "adminContent",
          agency: "reno police department",
          oca: "22-4537",
          supplementNum: "orig",
          reportedDate: "03/08/2022",
          reportedTime: "10:09",
          cadCallNum: "220670422",
          status: "report to follow",
          repIncType: "weapons law violations",
          location: "1 N Sierra St",
          city: "reno",
          zipCode: "89501",
          repDist: "J5F3",
          area: "RC",
          beat: "52",
          fromDate: "03/08/2022",
          fromTime: "10:09",
          empNum: "r16467/daniels,logan",
          assignment1: "patrol-grave-team 01",
          author: "rlhatz",
          assignment2: "transcribers",
          rmsTransfer: "successful",
          propTransStat: "successful",
          property: "none",
          approvingOfficer: "rlhatz",
          approvalDate: "03/10/2022",
          approvalTime: "12:21:49",
          arrestPcReport: "yes",
          criminalComplaint: "yes",
          writtenStatement: "yes",
          numOffenses: "1",
          offense: "62465",
          description: "unlawful use of a wh",
          complaintType: "",
          ac: "c",
          use: "n",
          bias: "88",
          loc: "13",
          numPr: "",
          moe: "",
          act: "",
          weaponForce: "",
          ibrs: "90z",
          no: "1",
          cargo: "",
          nvOffense: "62465",
          domViolence: "n",
          numChild: "",
          medAtn: "",
          protection: "",
          dvCard: "",
        },
      ],

      /* person summary */
      lstpersons: [
        {
          id: "personSumm1",
          link: "vic",
          involvement: "vic",
          invlNum: "1",
          name: "society",
          race: "",
          sex: "",
          dob: "",
        },
        {
          id: "personSumm2",
          link: "arr",
          involvement: "arr",
          invlNum: "1",
          name: "smith, cory",
          race: "w",
          sex: "m",
          dob: "05/27/1989",
        },
        {
          id: "personSumm3",
          link: "wit",
          involvement: "wit",
          invlNum: "1",
          name: "pauly, tye",
          race: "w",
          sex: "m",
          dob: "07/23/1968",
        },
      ],

      /* property summary */
      propSummaries: [
        {
          id: "propSumm1",
          involvement: "SZD",
          description: "Miscellaneous MISC whip multi colored",
        },
        {
          id: "propSumm2",
          involvement: "evd",
          description: "other: black whip with red handle",
        },
      ],

      /* Arrestees */
      arrestees: [
        {
          id: "arrest1",
          involvement: "arrestee",
          invlNum: "1",
          type: "individual",
          name: "smith, cory",
          mni: "2676286",
          race: "w",
          sex: "m",
          dob: "05/27/1989",
          age: "34",
          ethnicity: "not of hispanic origin",
          juvenile: "no",
          height: "6'00",
          weight: "200#",
          hairColor: "blonde/strawberry",
          eyeColor: "green",
          domViolence: "no",
          resStatus: "resident",
          ofnInvl: "1",
          vicOfndAge: "32",
          prn: "4513140",
          addresses: [
            {
              id: "arrestAddress1",
              type: "home",
              address: "335 Record St",
              city: "Reno",
              state: "NV",
              zipCode: "895212",
              date: "03/08/2022",
            },
          ],
          ids: [
            {
              id: "arrestId1",
              type: "social Security number",
              idNo: "",
            },
          ],
          aliases: [
            {
              id: "arrestAlias1",
              aliasName: "Ray",
              race: "white",
              sex: "male",
              dob: "05/27/1989",
              height: "6'00",
              weight: "200#",
              hairColor: "blonde/strawberry",
              eyeColor: "green",
            },
          ],
          dispos: [
            {
              id: "arrestDispo1",
              involvement: "arrested",
              arrestType: "arrested",
              arrestDate: "03/08/2022",
              arrestTime: "10:31:00",
              status: "booked",
              dispo: "misdemeanor",
              arrestLoc: "s lake st/mill st",
              city: "reno",
              repDist: "J7F2",
              birthPlace: "Texas",
              armed: "club, blackjack, brass knuckles",
              multiArrests: "not applicable",
              beat: "54",
              nocCharge: "62465",
              level: "M",
              chargeLiteral: "unlawful use of a wh",
              ibrs: "90Z",
              arrrestNoc: "62465",
            },
          ],
        },
        {
          id: "arrest2",
          involvement: "arrestee",
          invlNum: "2",
          type: "individual",
          name: "jones, Tom",
          mni: "2676286",
          race: "w",
          sex: "m",
          dob: "05/27/1989",
          age: "34",
          ethnicity: "hispanic",
          juvenile: "no",
          height: "6'00",
          weight: "200#",
          hairColor: "blonde/strawberry",
          eyeColor: "green",
          domViolence: "no",
          resStatus: "resident",
          ofnInvl: "2",
          vicOfndAge: "32",
          prn: "4513140",
          addresses: [
            {
              id: "arrestAddress2",
              type: "home",
              address: "10 10th st",
              city: "Reno",
              state: "NV",
              zipCode: "895212",
              date: "03/08/2022",
            },
          ],
          ids: [
            {
              id: "arrestId2",
              type: "social Security number",
              idNo: "",
            },
          ],
          aliases: [
            {
              id: "arrestAlias2",
              aliasName: "trigger",
              race: "white",
              sex: "male",
              dob: "05/27/1989",
              height: "6'00",
              weight: "200#",
              hairColor: "blonde/strawberry",
              eyeColor: "green",
            },
          ],
          dispos: [
            {
              id: "arrestDispo2",
              involvement: "arrested",
              arrestType: "arrested",
              arrestDate: "03/08/2022",
              arrestTime: "10:31:00",
              status: "booked",
              dispo: "misdemeanor",
              arrestLoc: "s lake st/mill st",
              city: "reno",
              repDist: "J7F2",
              birthPlace: "Texas",
              armed: "knife",
              multiArrests: "not applicable",
              beat: "54",
              nocCharge: "62465",
              level: "M",
              chargeLiteral: "possesion of knife",
              ibrs: "90Z",
              arrrestNoc: "62465",
            },
          ],
        },
      ],

      /* Cited */
      cited: [
        {
          id: "cited1",
          involvement: "cited",
          invlNum: "1",
          type: "individual",
          name: "ellis, jonathan",
          mni: "2643566",
          race: "white",
          sex: "male",
          dob: "12/26/1982",
          age: "39",
          ethnicity: "unknown",
          juvenile: "no",
          height: "5'6in",
          weight: "150#",
          hairColor: "brown",
          eyeColor: "blue",
          domViolence: "no",
          resStatus: "unknown",
          ofnInvl: "1",
          vicOfndAge: "39",
          prn: "4480748",
          addresses: [
            {
              id: "citeAddress1",
              type: "home",
              address: "335 Ralston St",
              city: "Reno",
              state: "NV",
              zipCode: "895212",
              date: "02/25/2022",
            },
          ],
          ids: [
            {
              id: "citeId1",
              type: "social Security number",
              idNo: "",
            },
          ],
          aliases: [
            {
              id: "citeAlias1",
              aliasName: "sammy",
              race: "white",
              sex: "male",
              dob: "12/26/1982",
              height: "5'6in",
              weight: "150#",
              hairColor: "brown",
              eyeColor: "blue",
            },
          ],
          dispos: [
            {
              id: "citeDispo1",
              involvement: "cited",
              arrestType: "citation",
              arrestDate: "02/25/2022",
              arrestTime: "15:00:00",
              status: "cited",
              dispo: "misdemeanor",
              arrestLoc: "1247 W 1st st #c",
              city: "reno",
              repDist: "I7F2",
              birthPlace: "",
              armed: "unarmed",
              multiArrests: "not applicable",
              beat: "38",
              nocCharge: "56456",
              level: "M",
              chargeLiteral: "disturbing the peace",
              ibrs: "90C",
              arrrestNoc: "56456",
            },
          ],
        },
        {
          id: "cited2",
          involvement: "cited",
          invlNum: "2",
          type: "individual",
          name: "willis, bruce",
          mni: "2643566",
          race: "white",
          sex: "male",
          dob: "12/26/1982",
          age: "39",
          ethnicity: "unknown",
          juvenile: "no",
          height: "5'6in",
          weight: "150#",
          hairColor: "brown",
          eyeColor: "blue",
          domViolence: "no",
          resStatus: "unknown",
          ofnInvl: "2",
          vicOfndAge: "39",
          prn: "4480748",
          addresses: [
            {
              id: "citeAddress2",
              type: "home",
              address: "5 oak st",
              city: "Reno",
              state: "NV",
              zipCode: "895212",
              date: "02/25/2022",
            },
          ],
          ids: [
            {
              id: "citeId2",
              type: "social Security number",
              idNo: "",
            },
          ],
          aliases: [
            {
              id: "citeAlias2",
              aliasName: "willy",
              race: "white",
              sex: "male",
              dob: "12/26/1982",
              height: "5'6in",
              weight: "150#",
              hairColor: "brown",
              eyeColor: "blue",
            },
          ],
          dispos: [
            {
              id: "citeDispo2",
              involvement: "cited",
              arrestType: "citation",
              arrestDate: "02/25/2022",
              arrestTime: "15:00:00",
              status: "cited",
              dispo: "misdemeanor",
              arrestLoc: "1247 W 1st st #c",
              city: "reno",
              repDist: "I7F2",
              birthPlace: "",
              armed: "unarmed",
              multiArrests: "not applicable",
              beat: "38",
              nocCharge: "56456",
              level: "M",
              chargeLiteral: "battery",
              ibrs: "90C",
              arrrestNoc: "56456",
            },
          ],
        },
      ],

      /* Subjects */
      subjects: [
        {
          id: "subject1",
          involvement: "subject",
          invlNum: "1",
          type: "individual",
          name: "espinoza, Donnie",
          mni: "1089821",
          race: "white",
          sex: "male",
          dob: "10/14/1994",
          age: "27",
          ethnicity: "unknown",
          juvenile: "no",
          height: "6'1in",
          weight: "180#",
          hairColor: "brown",
          eyeColor: "brown",
          domViolence: "no",
          resStatus: "unknown",
          ofnInvl: "1",
          vicOfndAge: "27",
          prn: "4422784",
          addresses: [
            {
              id: "subjectAddress1",
              type: "home",
              address: "335 4th st",
              city: "Reno",
              state: "NV",
              zipCode: "895212",
              date: "11/03/2021",
            },
          ],
          ids: [
            {
              id: "subjectId1",
              type: "social Security number",
              idNo: "",
            },
          ],
          aliases: [
            {
              id: "subjectAlias1",
              aliasName: "none",
              race: "white",
              sex: "male",
              dob: "10/14/1994",
              height: "6'1in",
              weight: "180#",
              hairColor: "brown",
              eyeColor: "brown",
            },
          ],
          dispos: [
            {
              id: "subjectDispo1",
              involvement: "subject",
              arrestType: "warning",
              arrestDate: "02/25/2022",
              arrestTime: "22:19:00",
              status: "warning",
              dispo: "misdemeanor",
              arrestLoc: "4th St/Lake St",
              city: "reno",
              repDist: "",
              birthPlace: "",
              armed: "whip",
              multiArrests: "not applicable",
              beat: "",
              nocCharge: "56456",
              level: "M",
              chargeLiteral: "possesion of whip",
              ibrs: "90C",
              arrrestNoc: "56456",
            },
          ],
        },
        {
          id: "subject2",
          involvement: "subject",
          invlNum: "2",
          type: "individual",
          name: "flintstone, fred",
          mni: "1089821",
          race: "white",
          sex: "male",
          dob: "10/14/1994",
          age: "27",
          ethnicity: "unknown",
          juvenile: "no",
          height: "6'1in",
          weight: "180#",
          hairColor: "brown",
          eyeColor: "brown",
          domViolence: "no",
          resStatus: "unknown",
          ofnInvl: "2",
          vicOfndAge: "27",
          prn: "4422784",
          addresses: [
            {
              id: "subjectAddress2",
              type: "home",
              address: "1 Cobblestone Lane",
              city: "Bedrock",
              state: "Granite",
              zipCode: "895212",
              date: "11/03/2021",
            },
          ],
          ids: [
            {
              id: "subjectId2",
              type: "social Security number",
              idNo: "",
            },
          ],
          aliases: [
            {
              id: "subjectAlias2",
              aliasName: "rocky",
              race: "white",
              sex: "male",
              dob: "10/14/1994",
              height: "6'1in",
              weight: "180#",
              hairColor: "brown",
              eyeColor: "brown",
            },
          ],
          dispos: [
            {
              id: "subjectDispo2",
              involvement: "subject",
              arrestType: "warning",
              arrestDate: "02/25/2022",
              arrestTime: "22:19:00",
              status: "warning",
              dispo: "misdemeanor",
              arrestLoc: "4th St/Lake St",
              city: "reno",
              repDist: "",
              birthPlace: "",
              armed: "axe",
              multiArrests: "not applicable",
              beat: "",
              nocCharge: "56456",
              level: "M",
              chargeLiteral: "possesion of axe",
              ibrs: "90C",
              arrrestNoc: "56456",
            },
          ],
        },
      ],

      /* law enforcement */
      cops: [
        {
          id: "cop1",
          involvement: "law enforcement personnel",
          invlNum: "1",
          type: "individual",
          name: "peralta, s rpd",
          prn: "4422783",
        },
        {
          id: "cop2",
          involvement: "law enforcement personnel",
          invlNum: "2",
          type: "individual",
          name: "santiago, s rpd patrol",
          prn: "44807949",
        },
      ],

      /* victims */
      victims: [
        {
          id: "victim1",
          involvement: "victim",
          invlNum: "1",
          type: "society/public",
          name: "society",
          mni: "2831433",
          race: "",
          sex: "",
          ethnicity: "",
          attack: "",
          injury: "",
          domViolence: "",
          resStatus: "",
          vicOfnAge: "",
          prn: "4419304",
          /* IBRS */
          ibrses: [
            {
              id: "ibrs1",
              vicInvlNo: "1",
              offCodes: "13B",
              injury: "",
              rel: "",
              involvement: "",
              invlNo: "",
              name: "",
              race: "",
              sex: "",
              dob: "",
            },
          ],
        },
        {
          id: "victim2",
          involvement: "victim",
          invlNum: "2",
          type: "individual",
          name: "espinoza, rpd det",
          mni: "2731611",
          race: "white",
          sex: "male",
          ethnicity: "hispanic origin",
          attack: "other",
          injury: "no visible injury",
          domViolence: "no",
          resStatus: "resident",
          vicOfnAge: "32",
          prn: "4419305",
          ibrses: [
            {
              id: "ibrs2",
              vicInvlNo: "2",
              offCodes: "13B/13B",
              injury: "none",
              rel: "st",
              involvement: "arr",
              invlNo: "1",
              name: "ewen, annee jo",
              race: "w",
              sex: "f",
              dob: "06/18/1987",
            },
          ],
        },
      ],

      /* Witnesses */
      witnesses: [
        {
          id: "witness1",
          involvement: "witness",
          invlNum: "1",
          type: "individual",
          name: "pauly, tye",
          mni: "452171",
          race: "white",
          sex: "male",
          dob: "07/23/1968",
          age: "53",
          ethnicity: "",
          juvenile: "no",
          height: "6'00",
          weight: "222#",
          hairColor: "brown",
          eyeColor: "brown",
          addresses: [
            {
              id: "witnessAddress1",
              type: "work/business",
              address: "40 E 4th St",
              city: "Reno",
              state: "NV",
              zipCode: "89501",
              date: "03/08/2022",
            },
          ],
          ids: [
            {
              id: "witnessId1",
              type: "social Security number",
              idNo: "",
            },
          ],
          phones: [
            {
              id: "witnessPhone1",
              phoneType: "business",
              phoneNo: "775-303-4080",
              date: "03/08/2022",
              empSchool: "reno ambassador",
            },
          ],
        },
        {
          id: "witness2",
          involvement: "witness",
          invlNum: "2",
          type: "individual",
          name: "barnes, harry",
          mni: "2676286",
          race: "w",
          sex: "m",
          dob: "05/27/1958",
          age: "64",
          ethnicity: "white",
          juvenile: "no",
          height: "6'00",
          weight: "185#",
          hairColor: "brown",
          eyeColor: "green",
          addresses: [
            {
              id: "witnessAddress2",
              type: "home",
              address: "123 Indian hill rd",
              city: "claremont",
              state: "CA",
              zipCode: "91711",
              date: "03/08/2022",
            },
          ],
          ids: [
            {
              id: "witnessId2",
              type: "social Security number",
              idNo: "",
            },
          ],
          phones: [
            {
              id: "witnessPhone2",
              phoneType: "home",
              phoneNo: "909-626-2722",
              date: "10/23/2022",
              empSchool: "UNR",
            },
          ],
        },
      ],

      /* Property */
      properties: [
        {
          id: "prop1",
          propNum: "1",
          invl1: "seized",
          invlDate: "11/03/2021",
          inCust: "yes",
          security: "no",
          barCode: "210004308",
          itemNo: "1",
          description: "whip multi colored",
          typ: "a",
          cat: "miscellaneous",
          article: "miscellaneous",
          ibrsType: "other",
          rcvLoc: "5 n park st",
          rcvCity: "reno",
          rcvSt: "nevada",
          repDist: "l1f5ic",
          beat: "rcis",
          area: "ic",
          enteredDate: "11/03/2021",
          enteredTime: "18:23",
          rmsTransfer: "successful",
          control: "r13346",
          link: "arr",
          invl2: "arr",
          invlNo: "1",
          name: "ewn, annee jo",
          race: "w",
          sex: "f",
          dob: "06/18/1987",
        },
        {
          id: "prop2",
          propNum: "2",
          invl1: "seized",
          invlDate: "11/03/2021",
          inCust: "yes",
          security: "no",
          barCode: "21009987",
          itemNo: "2",
          description: "black switchblade",
          typ: "a",
          cat: "knife",
          article: "knife",
          ibrsType: "knife",
          rcvLoc: "5 n park st",
          rcvCity: "reno",
          rcvSt: "nevada",
          repDist: "l1f5ic",
          beat: "rcis",
          area: "ic",
          enteredDate: "11/03/2021",
          enteredTime: "18:23",
          rmsTransfer: "successful",
          control: "r13346",
          link: "arr",
          invl2: "arr",
          invlNo: "1",
          name: "ewn, annee jo",
          race: "w",
          sex: "f",
          dob: "06/18/1987",
        },
      ],

      /* Modus Operandi */
      modOps: [
        {
          id: "modOp1",
          physEv: "photos/weapon",
          weaponUsed: "other",
          premType: "street, highway, alley/sidewalk",
          crimeCode: "weapons violations",
        },
      ],

      /* Narrative */
      narratives: [
        {
          id: "narr1",
          narrDescript: `Report Details: On 11/03/2021 at approximately 1607 hours, Officer Kent and myself (Officer Espinosa 14556) were conducting proactive patrol in the area of William Broadhead Park located at 5 Park St, Reno, Nevada, when we observed a female on the bike path manipulating a whip while standing next to her bicycle. The whip was a series of smallermulti colored ropes weaved together to an approximate length of 5 feet. The whip had a solid handle on one endwhile the other end was frayed, which is consistent with the basic construction of a common whip.Upon contact the subject was identified as Annee Ewen, hereinafter referred to as the Defendant. The Defendant was given information regarding the newly implemented ordinance regarding whips within the downtown corridor. A check through Reno PD Records showed the Defendant to have two active warrants out of the Reno Municipal Court for probation violations. The Warrants were confirmed via Reno PD Records.The Defendant was subsequently arrested for the outstanding Warrants. While en route to the WCSO the Defendant became belligerent and started yelling. Due to the patrol vehicle we were in we did not have a barrieror cage to separate ourselves from where the Defendant was seated on the passenger side of the back seat. TheDefendant continued to scream and proceeded to lean into the front compartment where we were seated in such a way Officer Kent and I had to stop while enroute to the WCSO to readjust how she was seated.Once the Defendant was readjusted we continued to the WCSO. Moments after we began driving, the Defendant continued to scream and proceeded to spit into the front of the patrol car. The saliva hit both Officer Kent and I on the backs of our necks and uniforms. I felt the saliva hit the back of my neck while Officer Kent stated he could feel the saliva on the side of his face as well his neck. Being that we were close to the WCSO, we continued to the facility. A spit hood was placed on the Defendant when we arrived at the WCSO. The Defendant was additionally charged with two counts of Battery on a Protected Person and was booked without further incident. The whip was siezed on scene and booked into Reno PD Evidence.`,
        },
      ],

      show_edit_modal: false,

      showall: true,
      ew_mode: false,
      editid: -1,
      editing: false,
      scroll_pos_edit_srch: 0,

      frm_search: {
        case_num: "",
        lic_num: "",
        vehicle_descr: "",
        note: "",
        s_del: "f",
        to_completed: "",
        from_completed: "",
      },
      lst_results: [],
      lst_lotlogs: [],
      bcs_cards: [{ name: "card1" }, { name: "card2" }],
    };
  },
  filters: {
    null_date: function (value) {
      if (value == "1900-01-01T00:00:00") {
        return "";
      } else {
        return window.Vue.$moment(value).format("YYYY-MM-DD");
      }
    },
  },
  watch: {},
  computed: {
    editing_label: function () {
      if (this.editid == 0) {
        return "Adding";
      } else {
        return "Editing";
      }
    },
    userx: function () {
      return this.$store.state.user;
    },

    show_login: function () {
      if (this.$store.state.user.email != "") {
        return true;
      } else {
        return false;
      }
    },
    user_email: function () {
      return this.$store.state.user.email;
    },
  },

  methods: {
    init: function (callback) {},
  },
  mounted() {
    this.$nextTick(() => {
      this.init();
    });
  },
};
</script>
